export enum RegistrationSubMode {
  Default = 0,

  Creation = 1,
  CreationWithoutAssociation = 2,
  Update = 3,
  CGUValidation = 4
}
